var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Code used from https://github.com/awesomejerry/react-native-qrcode-svg
// react-native-qrcode-svg is licensed under The MIT License (MIT)
// @ts-nocheck
import { useMemo } from 'react';
import { Svg, Defs, G, Path, Rect, Image, LinearGradient, Stop } from 'react-primitives-svg';
import genMatrix from './genMatrix';
import transformMatrixIntoPath from './transformMatrixIntoPath';
var renderLogo = function (_a) {
    var size = _a.size, logo = _a.logo, svgLogo = _a.svgLogo, logoSize = _a.logoSize, logoBackgroundColor = _a.logoBackgroundColor, logoMargin = _a.logoMargin, logoBorderRadius = _a.logoBorderRadius;
    var logoPosition = (size - logoSize - logoMargin * 2) / 2;
    var logoBackgroundSize = logoSize + logoMargin * 2;
    var logoBackgroundBorderRadius = logoBorderRadius + (logoMargin / logoSize) * logoBorderRadius;
    return (_jsxs(G, __assign({ transform: "translate(".concat(logoPosition, ", ").concat(logoPosition, ")") }, { children: [_jsx(G, { children: _jsx(Rect, { width: logoBackgroundSize, height: logoBackgroundSize, fill: logoBackgroundColor, clipPath: 'url(#clip-logo-background)', rx: logoBorderRadius, ry: logoBorderRadius }, void 0) }, void 0), _jsx(G, __assign({ transform: "translate(".concat(logoMargin, ", ").concat(logoMargin, ")") }, { children: Boolean(svgLogo) ? (_jsx(G, __assign({ transform: "translate(".concat(logoSize / 2, ", ").concat(logoSize / 2, ")") }, { children: svgLogo }), void 0)) : (_jsx(Image, { width: logoSize, height: logoSize, preserveAspectRatio: 'xMidYMid slice', href: logo, clipPath: 'url(#clip-logo)' }, void 0)) }), void 0)] }), void 0));
};
var QRCode = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 'hello world' : _b, _c = _a.size, size = _c === void 0 ? 100 : _c, _d = _a.color, color = _d === void 0 ? 'black' : _d, style = _a.style, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? 'white' : _e, svgLogo = _a.svgLogo, logo = _a.logo, _f = _a.logoSize, logoSize = _f === void 0 ? size * 0.2 : _f, _g = _a.logoBackgroundColor, logoBackgroundColor = _g === void 0 ? 'none' : _g, _h = _a.logoMargin, logoMargin = _h === void 0 ? 2 : _h, _j = _a.logoBorderRadius, logoBorderRadius = _j === void 0 ? 0 : _j, _k = _a.quietZone, quietZone = _k === void 0 ? 0 : _k, _l = _a.enableLinearGradient, enableLinearGradient = _l === void 0 ? false : _l, _m = _a.gradientDirection, gradientDirection = _m === void 0 ? ['0%', '0%', '100%', '100%'] : _m, _o = _a.linearGradient, linearGradient = _o === void 0 ? ['rgb(255,0,0)', 'rgb(0,255,255)'] : _o, _p = _a.ecl, ecl = _p === void 0 ? 'M' : _p, getRef = _a.getRef, onError = _a.onError;
    var result = useMemo(function () {
        try {
            return transformMatrixIntoPath(genMatrix(value, ecl), size);
        }
        catch (error) {
            if (onError && typeof onError === 'function') {
                onError(error);
            }
            else {
                // Pass the error when no handler presented
                throw error;
            }
        }
    }, [value, size, ecl]);
    if (!result) {
        return null;
    }
    var path = result.path, cellSize = result.cellSize;
    return (_jsxs(Svg, __assign({ ref: getRef, viewBox: [
            -quietZone,
            -quietZone,
            size + quietZone * 2,
            size + quietZone * 2
        ].join(' '), width: size, height: size, style: style }, { children: [_jsx(Defs, { children: _jsxs(LinearGradient, __assign({ id: 'grad', x1: gradientDirection[0], y1: gradientDirection[1], x2: gradientDirection[2], y2: gradientDirection[3] }, { children: [_jsx(Stop, { offset: '0', stopColor: linearGradient[0], stopOpacity: '1' }, void 0), _jsx(Stop, { offset: '1', stopColor: linearGradient[1], stopOpacity: '1' }, void 0)] }), void 0) }, void 0), backgroundColor ? (_jsx(G, { children: _jsx(Rect, { x: -quietZone, y: -quietZone, width: size + quietZone * 2, height: size + quietZone * 2, fill: backgroundColor }, void 0) }, void 0)) : null, _jsx(G, { children: _jsx(Path, { d: path, strokeLinecap: 'butt', stroke: enableLinearGradient ? 'url(#grad)' : color, strokeWidth: cellSize }, void 0) }, void 0), (logo || svgLogo) ?
                renderLogo({
                    size: size,
                    logo: logo,
                    svgLogo: svgLogo,
                    logoSize: logoSize,
                    logoBackgroundColor: logoBackgroundColor,
                    logoMargin: logoMargin,
                    logoBorderRadius: logoBorderRadius
                }) : null] }), void 0));
};
export default QRCode;
